
export default {
  // Subscription page
  'subscription.title': 'Planes de Suscripción',
  'subscription.subtitle': 'Elija el plan de suscripción perfecto para mejorar su experiencia en Pink Paradise',
  'subscription.why_subscribe': '¿Por qué suscribirse?',
  'subscription.why_description': 'Suscribirse a Pink Paradise desbloquea un mundo de funciones exclusivas y contenido premium, mejorando su experiencia y brindándole acceso a nuestras escorts verificadas.',
  'subscription.privacy_title': 'Privacidad Mejorada',
  'subscription.privacy_description': 'Todas las suscripciones incluyen funciones de privacidad mejoradas y mensajería segura.',
  'subscription.content_title': 'Contenido Exclusivo',
  'subscription.content_description': 'Acceda a fotos privadas, videos y servicios premium no visibles para usuarios gratuitos.',
  'subscription.support_title': 'Soporte Prioritario',
  'subscription.support_description': 'Los suscriptores reciben soporte y asistencia prioritaria al cliente.',
  
  // Free plan
  'subscription.free.title': 'Gratuito',
  'subscription.free.price': '0€/mes',
  'subscription.free.description': 'Acceso básico a la plataforma',
  'subscription.free.feature1': 'Vistas de perfil limitadas',
  'subscription.free.feature2': 'Explorar contenido público',
  'subscription.free.feature3': 'Crear tu propio perfil',
  'subscription.free.feature4': 'Sin mensajería',
  'subscription.free.feature5': 'Sin acceso a contenido premium',
  'subscription.free.feature6': 'Sin insignia de verificación',
  'subscription.free.feature7': 'Sin filtros de búsqueda avanzados',
  
  // Teaser plan
  'subscription.teaser.title': 'Pink Teaser',
  'subscription.teaser.price': '4,99€/mes',
  'subscription.teaser.description': 'Acceso mejorado con mensajería',
  'subscription.teaser.feature1': 'Vistas de perfil ilimitadas',
  'subscription.teaser.feature2': 'Mensaje hasta 5 perfiles diarios',
  'subscription.teaser.feature3': 'Ver tarifas y servicios',
  'subscription.teaser.feature4': 'Acceso a contenido básico',
  'subscription.teaser.feature5': 'Ver números de teléfono',
  'subscription.teaser.feature6': 'Filtros de búsqueda básicos',
  'subscription.teaser.feature7': 'Sin acceso a medios privados',
  
  // Regular plan
  'subscription.regular.title': 'Pink Regular',
  'subscription.regular.price': '19,99€/mes',
  'subscription.regular.description': 'Acceso completo con funciones premium',
  'subscription.regular.feature1': 'Mensajería ilimitada',
  'subscription.regular.feature2': 'Acceso completo al perfil',
  'subscription.regular.feature3': 'Ver y dejar reseñas',
  'subscription.regular.feature4': 'Acceso a contenido avanzado',
  'subscription.regular.feature5': 'Soporte prioritario',
  'subscription.regular.feature6': 'Filtros de búsqueda avanzados',
  'subscription.regular.feature7': 'Acceso a medios privados',
  
  // VIP plan
  'subscription.vip.title': 'Pink VIP',
  'subscription.vip.price': '100€/mes',
  'subscription.vip.description': 'Experiencia de élite con ventajas exclusivas',
  'subscription.vip.feature1': 'Todo lo del plan Regular',
  'subscription.vip.feature2': 'Insignia de verificación VIP',
  'subscription.vip.feature3': 'Posicionamiento prioritario en búsquedas',
  'subscription.vip.feature4': 'Acceso a contenido exclusivo',
  'subscription.vip.feature5': 'Soporte al cliente VIP',
  'subscription.vip.feature6': 'Análisis de perfil',
  'subscription.vip.feature7': 'Suscripciones exclusivas a escorts',
  
  // Buttons and messages
  'subscription.current_plan': 'Plan Actual',
  'subscription.free_cta': 'Plan Gratuito',
  'subscription.subscribe_cta': 'Suscribirse',
  'subscription.processing': 'Procesando...',
  'subscription.update_success': 'Suscripción Actualizada',
  'subscription.update_failed': 'Actualización Fallida',
  'subscription.error_try_again': 'Por favor intente más tarde.',
  'subscription.subscribed_to': 'Ahora está suscrito a {plan}',
  
  // New keys
  'subscription.subscribe_to': 'Suscribirse a',
  'subscription.thank_you': '¡Gracias por suscribirse!',
  'subscription.access_granted': 'Ahora tiene acceso al contenido premium',
  'subscription.premium_description': 'Acceda a fotos exclusivas, videos y servicios especiales',
  'subscription.monthly_subscription': 'Suscripción mensual',
  'subscription.month': 'mes',
  'subscription.cancel_anytime': 'Cancele en cualquier momento, sin compromiso',
  'subscription.feature_1_title': 'Fotos y videos exclusivos',
  'subscription.feature_1_description': 'Acceda a contenido reservado solo para suscriptores',
  'subscription.feature_2_title': 'Secretos privados',
  'subscription.feature_2_description': 'Descubra detalles íntimos y preferencias personales',
  'subscription.feature_3_title': 'Servicios premium',
  'subscription.feature_3_description': 'Acceda a servicios exclusivos no disponibles para otros',
  'subscription.terms_notice': 'Al suscribirse, acepta nuestros términos y condiciones y política de privacidad',
  'subscription.cancel': 'Cancelar',
  'subscription.continue': 'Continuar',
  'subscription.subscribe_for': 'Suscribirse por'
};
